import React, { Fragment, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { Link } from "react-router-dom";
import { getRiotAssetsContext } from "@outplayed/riot-assets";
import { GET_USER_STATE } from "api/graphql/queries";
import { useUserPremiumState } from "lib/hooks/userHooks";
import { TooltipContainer } from "@outplayed/tooltips";

const UserProfileLink = (props) => {
  const { getProfileIconImg } = getRiotAssetsContext();
  const { loading, data, error } = useQuery(GET_USER_STATE);
  const { getState } = data || {};
  const { lolSettings } = getState || {};
  const { summoners } = lolSettings || {};
  const summoner = (summoners && summoners[0]) || {};
  const { summonerName = "", regionId = "", iconId = "" } = summoner || {};
  const { isPremium } = useUserPremiumState();

  useEffect(() => {
    if (window) {
      if (isPremium) {
        localStorage.setItem("dontLoadGoogleCMP", true);
        window.isBoost = true;
        window.egApsUserSubscription = "true";
      } else {
        localStorage.setItem("dontLoadGoogleCMP", false);
        window.isBoost = false;
        delete window.egApsUserSubscription;
      }
    }
    return () => {
      window.isBoost = false;
      delete window.egApsUserSubscription;
      localStorage.setItem("dontLoadGoogleCMP", false);
    };
  }, [data]);

  if (loading || error || !summoner) return null;

  let boostIcon = (
    <Fragment>
      <TooltipContainer tooltipInfo={`BOOST user account`}>
        <img
          height={16}
          style={{ marginTop: 2, marginLeft: 8, marginRight: 8 }}
          src={"https://static.bigbrain.gg/assets/ugg/icons/nav/boost-header.svg"}
          alt={"Boost user account"}
        />
      </TooltipContainer>
    </Fragment>
  );

  return (
    <div className="masthead_user-profile">
      <Link className="user-profile-link" to={`/lol/profile/${regionId.toLowerCase()}/${summonerName.toLowerCase()}/overview`}>
        <img
          className="profile-icon"
          alt="Profile Avatar"
          src={iconId ? getProfileIconImg(iconId) : "https://static.bigbrain.gg/assets/ugg/icons/profile-icon.svg"}
        />
        <span>{summonerName}</span>
        {isPremium && boostIcon}
      </Link>
    </div>
  );
};

export default UserProfileLink;
